var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTzLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 412,
    viewBox: "0 0 403 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.5 180.817L0 59.2319L100.893 0.437256L202.355 59.2319L307.238 0.437256L403 59.2319L201.5 180.817Z",
    fill: "#B327FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.499 180.247V412L301.393 354.918V236.758L402.428 180.247V58.6616L201.499 180.247Z",
    fill: "#FA5AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201.499 180.247V412L101.605 354.918V236.758L0.569855 180.247V58.6616L201.499 180.247Z",
    fill: "#681695"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTzLogo);
export default __webpack_public_path__ + "static/media/TZLogo.2ccb9ebb691d613adffad19cf9a660f0.svg";
export { ForwardRef as ReactComponent };